import { render } from "./VipPricesList.vue?vue&type=template&id=1327c6d9"
import script from "./VipPricesList.vue?vue&type=script&lang=js"
export * from "./VipPricesList.vue?vue&type=script&lang=js"

import "./VipPricesList.vue?vue&type=style&index=0&id=1327c6d9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__